import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
export const nexaCodeSchema = v.object({
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
});
